const isImage = (element: HTMLElement | null): element is HTMLImageElement =>
  element?.tagName === 'IMG';

const isInput = (element: HTMLElement | null): element is HTMLInputElement =>
  element?.tagName === 'INPUT';

export { isImage, isInput }
